export const taskThemeColors = [
    "d0f490", //green
    "cb90f4", //purple
    "90f4f4", //blue
    "f4909f", //pink
    "f7f78f", //yellow
    "eeeeee", //grey
];
